var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Circle with Report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "circleBg",
    cx: 23.1,
    cy: 23,
    r: 22.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circleIcon",
    d: "m36.5 23.2h-5.7c-0.6 0-1 0.5-1 1v19.4c0.7-0.2 1.4-0.5 2.1-0.8v-17.5h3.6v15.5c0.7-0.5 1.4-1 2.1-1.6v-15c0-0.5-0.5-1-1.1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "circleIcon",
    d: "m19.2 20.1v24.3c0.7 0.1 1.4 0.2 2.1 0.3v-23.5h3.6v23.5c0.7-0.1 1.4-0.1 2.1-0.3v-24.3c0-0.6-0.5-1-1-1h-5.7c-0.6 0-1.1 0.5-1.1 1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "circleIcon",
    d: "m10.7 40.8v-16.6h3.6v18.7c0.7 0.3 1.4 0.6 2.1 0.8v-20.5c0-0.6-0.5-1-1-1h-5.7c-0.6 0-1 0.5-1 1v16.1c0.6 0.5 1.3 1 2 1.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "circleIcon",
    d: "m39.7 16.9c0-0.4-0.2-0.9-0.8-1.1l-3.4-0.8c-0.6-0.1-1.1 0.2-1.3 0.7-0.1 0.5 0.2 1.1 0.8 1.2l0.9 0.2-2.7 1.6-10.2-5.7c-0.3-0.2-0.7-0.2-1 0l-10 4.8-4.9-2.9c-0.5-0.3-1.1-0.2-1.4 0.3s-0.2 1.1 0.3 1.4l5.3 3.2c0.3 0.2 0.7 0.2 1 0.1l10.2-4.6 10.3 5.7c0.3 0.1 0.6 0.2 1.1 0l3.3-2-0.2 1c-0.2 1.3 1.7 1.7 2 0.4l0.7-3.3c-0.1-0.1-0.1-0.1 0-0.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "circleBorder",
    d: "m23.1 0c-12.7 0-23 10.3-23 23s10.3 23 23 23 23-10.3 23-23-10.3-23-23-23zm0 44.5c-11.9 0-21.5-9.7-21.5-21.5s9.6-21.4 21.5-21.4 21.4 9.6 21.4 21.4-9.6 21.5-21.4 21.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.b870ac1f2007cbbaa439f22c57ea824c.svg";
export { ForwardRef as ReactComponent };